import React from 'react';

export default React.createContext({});



// WEBPACK FOOTER //
// ./src/common/context/PropsAPIContext/index.js